export default "/assets/site/images/szabadido.jpg?9b0165d7e7424d6ecfeea195860527d1";